import {
  ActionTypes,
  getUser,
  GET_USER_ERROR,
  GET_USER_STARTED,
  GET_USER_SUCCESS,
  POST_USER_LOGOUT,
} from './types'

interface IState {
  user: getUser
  loading: boolean
  error: boolean
  isAuth: boolean
}

const INITIAL_STATE: IState = {
  user: {
    active: false,
    email: '',
    company: '',
    role: '',
    last_login: '',
    createdDate: '',
    id: 0,
    name: '',
  },
  isAuth: false,
  loading: false,
  error: false,
}

export const userReducer = (state = INITIAL_STATE, action: ActionTypes): IState => {
  const newState = Object.assign({}, state)
  switch (action.type) {
    case GET_USER_STARTED:
      newState.loading = true
      break
    case GET_USER_SUCCESS:
      newState.loading = false
      newState.isAuth = true
      newState.user = action.payload
      break
    case GET_USER_ERROR:
      newState.isAuth = false
      newState.loading = false
      newState.error = true
      break
    case POST_USER_LOGOUT:
      newState.isAuth = false
      newState.user = {
        active: false,
        email: '',
        company: '',
        role: '',
        last_login: '',
        createdDate: '',
        id: 0,
        name: '',
      }
      break
    default: {
      break
    }
  }

  return newState
}
